//- Model
import DispReqBatchModel from '@/models/Warehouse/WhDispatchRequestBatch'
//- Appends & Includes
import DispReqBatchIncludes from './DispatchRequestBatchIncludes'
//- Route
let route = process.env.VUE_APP_API_ROUTE + '/wh_dispatch_request_batch'

//- Create, Fetch, Update, Delete
const fetchDispatchRequestBatch = async function() {
    try {
        let dispReqBatch = await DispReqBatchModel.include(
            DispReqBatchIncludes
        ).get()
        return dispReqBatch
    } catch (error) {
        console.log('Error en fetch disp_req_batch: ', error)
        return error.response.data
    }
}

const fetchById = async function(idDispatchRequestBatch) {
    try {
        let pchOrder = await DispReqBatchModel.include(
            DispReqBatchIncludes
        ).find(idDispatchRequestBatch)
        return pchOrder
    } catch (error) {
        return error.response.data
    }
}
//
export default {
    fetchDispatchRequestBatch,
    fetchById,
}
